import React, { useEffect, useState } from 'react';
import { CheckCircle } from 'lucide-react';
const NAMES = ['Ana M.', 'Sofía R.', 'Valentina G.', 'Camila P.', 'Isabella L.', 'Lucía F.', 'Mariana T.', 'Gabriela S.', 'Elena D.', 'Martina B.'];
const CITIES = ['Medellín, Colombia', 'Montevideo, Uruguay', 'Quito, Ecuador', 'San José, Costa Rica', 'Caracas, Venezuela', 'Buenos Aires, Argentina', 'Santiago, Chile', 'Lima, Perú', 'Ciudad de México, México', 'Bogotá, Colombia'];
export function PurchaseNotification() {
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      showNotification();
    }, 5000);
    const interval = setInterval(() => {
      showNotification();
    }, 12000 + Math.random() * 5000); // Random interval between 12-17s
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  const showNotification = () => {
    const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
    const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
    setData({
      name: randomName,
      city: randomCity
    });
    setVisible(true);
    // Hide after 5 seconds
    setTimeout(() => {
      setVisible(false);
    }, 5000);
  };
  if (!visible) return null;
  return <div className="fixed bottom-4 left-4 z-50 animate-in slide-in-from-bottom-5 fade-in duration-500" data-id="element-163">
      <div className="bg-white rounded-lg shadow-xl p-4 flex items-center gap-3 border-l-4 border-green-500 max-w-xs" data-id="element-164">
        <div className="bg-green-100 p-2 rounded-full" data-id="element-165">
          <CheckCircle className="w-5 h-5 text-green-600" data-id="element-166" />
        </div>
        <div data-id="element-167">
          <p className="text-sm font-medium text-gray-900" data-id="element-168">
            <span className="font-bold" data-id="element-169">{data.name}</span> de {data.city}
          </p>
          <p className="text-xs text-gray-600" data-id="element-170">
            compró <b data-id="element-171">Que Estudie Sin Pelear</b>
          </p>
          <p className="text-[10px] text-gray-400 mt-1" data-id="element-172">hace unos instantes</p>
        </div>
      </div>
    </div>;
}